import CloneFlowDialog from './CloneFlowDialog';
import FlowBuilderHeader from 'components/Flow/FlowBuilderHeader';
import FlowRender from 'pages/Flow/FlowRender';
import FlowSaveAsNewVersionDialog from './FlowSaveAsNewVersionDialog';
import FlowSidePanel from 'pages/Flow/FlowSidePanel/FlowSidePanel';
import FlowVersioningPrompt from './FlowVersioningPrompt';
import LiveRampLoader from 'BaseComponents/LiveRampLoader';
import React, { useContext } from 'react';
import {
  Box, Container,
} from '@mui/material';
import { FlowBuilderContext } from 'pages/Flow/FlowBuilder/FlowBuilderContextProvider';
import { Redirect } from 'react-router-dom';
import { cleanRoom } from 'utils/spaUrls';
import { styled } from '@mui/material/styles';


const MainContainer = styled((props) => (
  <Container maxWidth={false} disableGutters {...props} />
))(() => ({
  maxWidth: '100vw',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
}));

export const FlowCanvas = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  border: `1px solid ${theme.palette.secondary.light}`,
  borderRadius: theme.spacing(0.5),
  flex: 1,
  minHeight: 'calc(100vh - 140px)',
  position: 'relative',
  overflow: 'hidden',
}));

const FlowBuilderForm = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

const LoadingSpinner = () => (
  <Box mt={20} display='flex' justifyContent='center'>
    <LiveRampLoader />
  </Box>
);

export const FlowBuilderLayout = () => {
  const {
    flowId,
    crId,
    flow,
    cleanRoomFlow,
    editMode,
    isViewMode,
    handleFlowChangeConfirmation,
    flowUpdateSuccess,
    handleFlowSubmit,
    handleNameInput,
    handleDescriptionInput,
  } = useContext(FlowBuilderContext);

  if (flowUpdateSuccess) {
    return <Redirect to={cleanRoom.flowLanding(crId)} />;
  }

  if (!flow.displayID) {
    return <LoadingSpinner />;
  }

  return (
    <MainContainer>
      <FlowBuilderForm onSubmit={handleFlowSubmit}>
        <FlowBuilderHeader
          flow={flow}
          cleanRoomFlow={cleanRoomFlow}
          onNameChange={handleNameInput}
          onDescriptionChange={handleDescriptionInput}
          editMode={editMode}
          isViewMode={isViewMode}
        />

        <FlowCanvas>
          <FlowRender
            crId={crId}
            flowId={flowId}
            editMode={editMode}
            confirmAction={handleFlowChangeConfirmation}
          />
        </FlowCanvas>
      </FlowBuilderForm>

      <FlowSidePanel />
      <FlowVersioningPrompt />
      <FlowSaveAsNewVersionDialog />
      <CloneFlowDialog />
    </MainContainer>
  );
};
